export const engagementInAppMessageColorProfiles = "/engagement/in_app_message_color_profiles";
